const CounterCardsSkeleton = () => {
  return (
    <div className="cards-section-wrapper" style={{ marginTop: '30px' }}>
      <div className="row gy-4 gx-3 justify-content-start">
        <div className="col-xl-12">
          <div className="row g-4 modern-cards-container">
            {[1, 2, 3, 4].map((i) => (
              <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12" key={i}>
                <div className="card counter modern-card">
                  <div className="card-glow" style={{ opacity: 0.2 }}></div>
                  <div className="card-background"></div>
                  
                  <div className="card-body text-center">
                    {/* Icon skeleton */}
                    <div className="card-element-spacing">
                      <div className="card-box-icon">
                        <div className="placeholder-glow">
                          <div 
                            className="placeholder rounded-circle bg-secondary-subtle" 
                            style={{ width: '72px', height: '72px', margin: '0 auto' }}
                          ></div>
                        </div>
                      </div>
                    </div>

                    {/* Label skeleton */}
                    <div className="card-element-spacing">
                      <div className="placeholder-glow">
                        <span 
                          className="placeholder col-8 mx-auto rounded d-block" 
                          style={{ height: '18px' }}
                        ></span>
                      </div>
                    </div>

                    {/* Count skeleton */}
                    <div className="card-element-spacing">
                      <div className="placeholder-glow">
                        <span 
                          className="placeholder rounded-pill d-block mx-auto" 
                          style={{ 
                            width: '100px', 
                            height: '36px',
                            background: 'linear-gradient(135deg, #e2e8f0, #cbd5e1)'
                          }}
                        ></span>
                      </div>
                    </div>

                    {/* Subtitle skeleton */}
                    <div className="card-element-spacing">
                      <div className="placeholder-glow">
                        <span 
                          className="placeholder col-10 mx-auto rounded d-block" 
                          style={{ height: '14px' }}
                        ></span>
                      </div>
                    </div>
                  </div>

                  <div className="card-corner"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .card.counter {
          position: relative;
          overflow: hidden;
        }

        .card-element-spacing {
          margin-bottom: 1rem;
        }

        .card-box-icon {
          display: flex;
          justify-content: center;
          margin-bottom: 0.5rem;
        }

        @keyframes placeholder-glow {
          50% { opacity: 0.5; }
        }

        .placeholder {
          animation: placeholder-glow 2s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default CounterCardsSkeleton;